import { InjectionToken } from '@angular/core';

export const CMS_DATEPICKER_CONFIG = new InjectionToken<string>(
  'CMS_DATEPICKER_CONFIG'
);
